import React, { useContext } from "react";
import { StepContext } from "../../App";

function NextButton() {
    const [ step, setStep ] = useContext( StepContext );

    const onNextClick = () => {
        const weShouldProbablyDoThisWithARef = document.getElementsByClassName( "configuration-wrapper" )[0];

        weShouldProbablyDoThisWithARef.scroll( {
            top: 0,
            left: 0,
            behavior: "smooth",
        } );
        setStep( step + 1 );
    };

    return <>
        <div className="flex category-container next-container-style">
            <button className="flex next-button config-button" onClick={onNextClick}>Weiter ➜</button>
        </div>
    </>;


}

export default NextButton;
